var app = angular.module("leonardo");

var TagsListFilter = function($scope, $controller, $state) {

  $controller('FiltersBaseController', { $scope: $scope });
  $scope.system = $state.current.system;

  $scope.types = [
      {id:true, name:'Published'},
      {id:false, name:'Unpublished'}
  ];

  if ($scope.system) {
    $scope.filterService.showFilters(['is_published']);
  }

  if ($scope.system) {
    $scope.filters_options = [
      {
        id: 'is_published',
        name: 'Published Status',
        label: null,
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'Published Status',
        condition: true,
        options: $scope.types
      },
      {
        id: 'is_search_by_attribute',
        name: 'Attribute/Description',
        label: null,
        inline: false,
        type: 'text',
        placeholder: 'Attribute/Description Contains',
        condition: true
      }
    ];
  }
  else {
    $scope.filters_options = [
    {
      group: 'location',
      name: 'By Location',
      elements: [
        {
          id: 'enabled_for_dynamic_forms',
          name: 'Dynamic Form',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'Dynamic Form',
          condition: true,
          options: $scope.types
        },
        {
          id: 'enabled_for_reports',
          name: 'Reporting',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'Reporting',
          condition: true,
          options: $scope.types
        },
        {
          id: 'is_search_by_displayname',
          name: 'Display Name',
          label: null,
          inline: false,
          type: 'text',
          placeholder: 'Display Name Contains',
          condition: true
        },
        {
          id: 'is_search_by_attribute',
          name: 'Attribute/Description',
          label: null,
          inline: false,
          type: 'text',
          placeholder: 'Attribute/Description Contains',
          condition: true
        }
    ]
}];
  }


};

app.controller('TagsListFilter', ['$scope', '$controller', '$state', TagsListFilter]);
